// Variante 3, Motion-Design: Buchstaben, Wörter, die beim Scrollen aufleuchten, seitliche Galerie,
// Laufband nach Scrolltempo, magnetische Knöpfe. Alles nur mit Bewegung (html.motion), sonst bleibt die Seite ruhig.
(() => {
  const html = document.documentElement;
  const an = html.classList.contains('motion');

  if (!an) return;

  // Buchstaben einzeln, damit sie nacheinander aufsteigen
  document.querySelectorAll('[data-buchstaben]').forEach((el) => {
    const text = el.textContent;
    el.setAttribute('aria-label', text.trim());
    el.innerHTML = [...text].map((z, i) => (z === ' ' ? ' ' : `<span class="bst" aria-hidden="true" style="--i:${i}">${z}</span>`)).join('');
  });
  requestAnimationFrame(() => html.classList.add('buchstaben-los'));

  // Wörter, die beim Scrollen nacheinander aufleuchten
  const absaetze = [...document.querySelectorAll('[data-woerter]')].map((el) => {
    el.innerHTML = el.textContent.trim().split(/\s+/).map((w) => `<span class="wort">${w}</span>`).join(' ');
    return { el, woerter: [...el.querySelectorAll('.wort')] };
  });

  // Seitliche Galerie: Abschnitt bleibt stehen, die Spur läuft nach links
  const galerien = [...document.querySelectorAll('[data-quer]')].map((el) => ({ el, spur: el.querySelector('[data-quer-spur]'), zahl: el.querySelector('[data-quer-zahl]'), videos: [...el.querySelectorAll('video')] }));
  galerien.forEach((g) => new IntersectionObserver(([e]) => g.videos.forEach((v) => (e.isIntersecting ? v.play().catch(() => {}) : v.pause()))).observe(g.el));

  // Laufband: Grundtempo plus Scrolltempo, Richtung folgt dem Scrollen
  const baender = [...document.querySelectorAll('[data-band-tempo]')].map((el) => ({ el, x: 0 }));

  // Erster Bildschirm tritt beim Scrollen zurück
  const held = document.querySelector('.sh__inhalt');

  let letzte = scrollY;
  let richtung = 1;
  let tempo = 0;
  const schleife = () => {
    const y = scrollY;
    const delta = y - letzte;
    letzte = y;
    if (Math.abs(delta) > 0.5) richtung = Math.sign(delta);
    tempo += (Math.abs(delta) - tempo) * 0.2;
    const h = innerHeight;

    if (held && y < h * 1.2) {
      const p = Math.min(1, y / h);
      held.style.transform = `translate3d(0, ${(p * h * 0.25).toFixed(1)}px, 0) scale(${(1 - p * 0.12).toFixed(3)})`;
      held.style.opacity = (1 - p * 1.2).toFixed(3);
    }

    absaetze.forEach(({ el, woerter }) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > h) return;
      const p = Math.min(1, Math.max(0, (h * 0.85 - r.top) / (r.height + h * 0.35)));
      const grenze = p * woerter.length;
      woerter.forEach((w, i) => w.classList.toggle('ist-an', i < grenze));
    });

    galerien.forEach((g) => {
      const r = g.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > h) return;
      const p = Math.min(1, Math.max(0, -r.top / (r.height - h)));
      // Weg bis zur letzten Karte plus Seitenrand; scrollWidth/innerWidth ließen Rand und Scrollleiste weg, die letzte Karte war abgeschnitten
      const ende = g.spur.lastElementChild.getBoundingClientRect().right - g.spur.getBoundingClientRect().left + parseFloat(getComputedStyle(g.spur).paddingRight) - g.spur.clientWidth;
      g.spur.style.transform = `translate3d(${(-p * Math.max(0, ende)).toFixed(1)}px, 0, 0)`;
      if (g.zahl) g.zahl.style.setProperty('--p', p);
    });

    baender.forEach((b) => {
      const halb = b.el.scrollWidth / 2;
      b.x -= (0.5 + Math.min(14, tempo * 0.3)) * richtung;
      if (b.x <= -halb) b.x += halb;
      if (b.x > 0) b.x -= halb;
      b.el.style.transform = `translate3d(${b.x.toFixed(1)}px, 0, 0)`;
    });
    requestAnimationFrame(schleife);
  };
  requestAnimationFrame(schleife);

  // Magnetische Knöpfe (nur mit Maus)
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.button').forEach((k) => {
      k.addEventListener('pointermove', (e) => {
        const r = k.getBoundingClientRect();
        k.style.transform = `translate(${((e.clientX - r.left - r.width / 2) * 0.25).toFixed(1)}px, ${((e.clientY - r.top - r.height / 2) * 0.35).toFixed(1)}px)`;
      });
      k.addEventListener('pointerleave', () => (k.style.transform = ''));
    });
  }
})();
